/* eslint-disable react/prop-types */
import React from "react";
import "./Button.css";

export default function Button({ text, className, href, newTab, rel }) {
  return (
    <div className={className}>
      <a
        className="main-button"
        href={href}
        target={newTab && "_blank"}
        rel={rel}
      >
        {text}
      </a>
    </div>
  );
}
